export default __webpack_public_path__ + "static/media/875.47e46f7b.png";